import { render, staticRenderFns } from "./EntityInviteForm.vue?vue&type=template&id=2a6a3b86&"
import script from "./EntityInviteForm.vue?vue&type=script&lang=js&"
export * from "./EntityInviteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports